/**
 * @description 通用工具函数
 * 需要注入到Vue实例中的通用函数放到这里
 */
import { hasHttp } from "./file";
import store from "@/store";

/**
 * @description 将正常数字转换为带千分位的数字
 * @param {string | number} num 需要转换千分位的数字
 * @returns {string} 返回带千分位的数字
 */
export const setThousandths = (num) => {
	if (!num) {
		return num;
	}

	// 将数字转换为字符串
	const numStr = num.toString();
	// 分离整数部分和小数部分
	const [integerPart, decimalPart] = numStr.split(".");
	// 对整数部分添加千分位分隔符
	const formattedIntegerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

	// 如果有小数部分，则拼接小数部分
	return decimalPart ? `${formattedIntegerPart}.${decimalPart}` : formattedIntegerPart;
};

/**
 * 判断是否有权限
 * @description 可以传入一个或多个权限标识，只要有一个权限标识符合即返回true
 * @param {string | string[]} permission 权限标识
 * @returns {boolean} true | false
 */
export const hasPermission = (permission) => {
	if (!permission) {
		return false;
	}

	const permissions = store.getters.permissions;

	if (Array.isArray(permission)) {
		return permission.some((item) => permissions.includes(item.toLowerCase()));
	}

	return permissions.includes(permission.toLowerCase());
};

const ossTypeMap = {
	// 款式相关图片
	ab: "01",
	// 基础图片
	ac: "02",
	// 原文件地址，由于受谷歌插件影响（会被屏蔽），所以弃用
	ad: "03",
	ae: "04",
	// 私有文件
	af: "05",
	// 新的文件地址
	ag: "06"
};

/**
 * @description 根据传入的url获取对应的oss host
 * @param {string} url 文件地址
 * @returns {string} oss host
 */
export const addOssHostToFileUrl = (url) => {
	// 如果是http/https开头的文件直接返回（说明可以正常访问）
	if (hasHttp(url)) {
		return url;
	}

	const ossType = url.split("/")[0];

	// 如果是oss类型的文件，添加对应的oss host
	if (ossType in ossTypeMap) {
		return `https://s${ossTypeMap[ossType]}.singbada.cn/${url}`;
	}

	return `https://zyimage.singbada.cn/${url}`;
};

/**
 * @description 获取缩略图地址
 * @param {string | string[]} data 只处理字符串和数组两种类型参数
 * @param {boolean} _thumbnail 是否添加缩略图后缀
 * @returns {string | string[]} 返回处理后的缩略图地址
 */
export function splicingThumbnail(data, _thumbnail = true) {
	if (!data) {
		return data;
	}

	const regex = /^(http|https):\/\/.*\.singbada\.cn.*$/;

	if (typeof data === "string") {
		const newUrl = addOssHostToFileUrl(data);

		if (regex.test(newUrl)) {
			if (_thumbnail) {
				return `${newUrl}?x-oss-process=style/style_small`;
			} else {
				return newUrl;
			}
		}
	}

	if (Array.isArray(data)) {
		return data.map((item) => {
			const newUrl = addOssHostToFileUrl(item);

			if (regex.test(newUrl)) {
				if (_thumbnail) {
					return `${newUrl}?x-oss-process=style/style_small`;
				} else {
					return newUrl;
				}
			}

			return newUrl;
		});
	}

	return data;
}

/**
 * @description 空文本转换为指定符号
 * @param {string} text
 * @returns string
 */
export const emptyTextConversion = (text, symbol = "-") => {
	if (text === null || text === undefined || text === "") {
		return symbol;
	}

	return text;
};

/**
 * 对token进行脱敏
 * @description 将token进行脱敏处理，只显示前4位和后4位，中间用***代替
 * @param {string} token
 * @returns string
 */
export const tokenDesensitization = (token) => {
	if (!token) {
		return "";
	}

	return `${token.slice(0, 4)}***${token.slice(-4)}`;
};
